import { CtaButton } from '@/feed/Feed.interface'

function Cta({
  buttons,
  sendClickStat,
  className
}: {
  buttons: CtaButton[]
  sendClickStat: (buttonNumber: number) => Promise<void>
  className: string
}) {
  const generateUrl = (button: CtaButton) => {
    if (button.destinationType === 'dismiss') {
      return 'pulsate://backbtn'
    }
    return (
      button.destinationUrl ??
      (button as { destination?: string }).destination ??
      '#'
    )
  }

  return (
    <div className={`${className} mt-5 pb-15`}>
      {buttons.map((button) => {
        return (
          <a
            href={generateUrl(button)}
            onClick={() => {
              sendClickStat(button.orderNumber)
            }}
            key={button.orderNumber}
            style={{
              backgroundColor: button.btnColor,
              color: button.txtColor
            }}
            className="text-center no-underline overflow-hidden text-ellipsis whitespace-nowrap font-semibold p-4 w-full block rounded first:text-white first:bg-green nth-[2]:mt-4.5 nth-[2]:bg-white shadow-2xl nth-[2]:text-green">
            {button.label}
          </a>
        )
      })}
    </div>
  )
}

export default Cta
